import type { GatsbyBrowser } from "gatsby";

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  document.cookie = `ane_redirect=${location.href};path=/;max-age=900000;domain=.${location.hostname}`;
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  document.cookie = `ane_redirect=${window.location.href};path=/;max-age=900000;domain=.${window.location.hostname}`;
};
